import { styled } from '@volkswagen-onehub/components-core';

interface StyledMaskContainerProps {
  width: string;
  height: string;
}

interface StyledIconProps {
  width: string;
}

interface StyledMaskProps {
  border?: boolean;
  raised?: boolean;
  background?: string;
}

export const StyledMaskContainer = styled.div<StyledMaskContainerProps>(
  ({ width, height }) => `
  height: ${height};
  width: ${width};
  position: relative;
`
);

export const StyledIcon = styled.span<StyledIconProps>(
  ({ width }) => `
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) rotate(45deg) translate(calc(${width} / 2)) rotate(-45deg);
`
);

export const StyledMask = styled.div<StyledMaskProps>(
  ({ border, raised, theme, background }) => `
  background: ${background || theme.colors.background.primary};
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;

  ${border ? `border: 5px solid ${theme.colors.background.primary};` : ''}
  ${raised ? `box-shadow: 0px 0px 10px 0px #0000001A;` : ''}

  > img {
    width: 100%;
  }
`
);

export const StyledCircleMask = styled(StyledMask)`
  border-radius: 50%;
`;
